import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RoleState, RoleType } from './roleTypes'

const initialState: RoleState = {
  selectedRole: null,
  roles: []
}

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setSelectedRole(state, action: PayloadAction<RoleState['selectedRole']>) {
      state.selectedRole = action.payload
    },
    setRoles(state, action: PayloadAction<RoleType[]>) {
      state.roles = action.payload
    }
  }
})

export const roleReducer = roleSlice.reducer
